
"use strict";
var app = angular.module('MetronicApp');
require('./angular/relativeinterval')(angular, app);
require('./angular/metric_format')(angular, app);

require('./angular/dimensions_service')(angular, app);
require('./angular/deep_query_service')(angular, app);
require('./angular/deep_query_store')(angular, app);

require('./angular/settings_service')(angular, app);
require('./angular/dashboard_query_service')(angular, app);
require('./angular/integrations_service')(angular, app);
require('./angular/user_live_view_service')(angular, app);
require('./angular/smart_adserver_manager')(angular, app);

// LEGACY (#deep-sandbox)
require('./angular/select_directive')(angular, app);
require('./angular/filter_directive')(angular, app);
require('./angular/group_directive')(angular, app);

